import { useState } from "react";

import { AppointmentResponse } from "@/api";
import { AppointmentCreationDialog } from "@/common/components/appointments/appointment-creation/AppointmentCreationDialog";
import { AppointmentEditDialog } from "@/common/components/appointments/appointment-edit/AppointmentEditDialog";
import { ListCalendar } from "@/common/components/calendar/ListCalendar";
import { CounselorSelect } from "@/common/components/counselor-select/CounselorSelect";
import { mapAppointmentEvent } from "@/common/hooks/appointmentCalendar.utils";
import { useTranslation } from "@/translations";

import { AppointmentRow } from "./components/appointment-row/AppointmentRow";
import { useAppointments } from "./hooks/useAppointments";

export function Appointments() {
  const { t } = useTranslation();
  const { appointments, isLoading, onDateRangeChange, selectedCounselorId, onCounselorChange } = useAppointments();
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [editingAppointment, setEditingAppointment] = useState<AppointmentResponse | null>(null);

  return (
    <>
      <ListCalendar<AppointmentResponse>
        events={appointments}
        mapEvent={mapAppointmentEvent}
        noEventsMessage={t("calendar.noAppointments")}
        renderEvent={(appointment) => (
          <AppointmentRow appointment={appointment} onOpen={() => setEditingAppointment(appointment)} />
        )}
        onDateChange={onDateRangeChange}
        isLoading={isLoading}
        onCreateClick={() => setIsCreateOpen(true)}
        onEventClick={(appointment: AppointmentResponse) => setEditingAppointment(appointment)}
        customHeaderFilter={
          <CounselorSelect selectedCounselor={selectedCounselorId} onSelectCounselor={onCounselorChange} />
        }
      />
      {isCreateOpen && <AppointmentCreationDialog onClose={() => setIsCreateOpen(false)} />}
      {editingAppointment && (
        <AppointmentEditDialog appointment={editingAppointment} onClose={() => setEditingAppointment(null)} />
      )}
    </>
  );
}
